// src/sections/About.js
import React from 'react';
import styled from 'styled-components';
import { colors, fonts, fontSizes, mq, radii, shadows, space } from '../styles/tokens';
import { SectionHeading } from '../components/SectionHeading';
import { Chip, ChipRow } from '../components/Chip';
import { useInView } from '../hooks/useInView';
import profile from '../assets/profile.webp';

const Section = styled.section`
  padding: ${space[10]} ${space[4]};
  max-width: 1100px;
  margin: 0 auto;
  ${mq.md} { padding: ${space[12]} ${space[5]}; }
`;

const Grid = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: ${space[6]};
  ${mq.md} { grid-template-columns: 320px 1fr; align-items: center; }
`;

const Frame = styled.div`
  justify-self: center;
  width: 100%;
  max-width: 320px;
  aspect-ratio: 4/5;
  padding: 2px;
  background: linear-gradient(135deg, ${colors.grad1}, ${colors.accent});
  border-radius: ${radii.xl};
  box-shadow: ${shadows.card};
`;

const FrameInner = styled.div`
  width: 100%;
  height: 100%;
  border-radius: calc(${radii.xl} - 2px);
  overflow: hidden;
  background: ${colors.bgElev};
  box-shadow: inset 0 0 20px rgba(0, 0, 0, 0.4);
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;

const Text = styled.div`
  opacity: ${(p) => (p.$inView ? 1 : 0)};
  transform: translateY(${(p) => (p.$inView ? '0' : '16px')});
  transition: opacity 600ms cubic-bezier(0.22, 1, 0.36, 1),
              transform 600ms cubic-bezier(0.22, 1, 0.36, 1);

  p {
    font-family: ${fonts.sans};
    font-size: ${fontSizes.md};
    color: ${colors.textDim};
    line-height: 1.6;
    margin-bottom: ${space[3]};
  }
  p:last-of-type { margin-bottom: 0; }
`;

const About = () => {
  const [ref, inView] = useInView({ threshold: 0.2 });

  return (
    <Section id="about" aria-labelledby="about-heading" ref={ref}>
      <SectionHeading prefix="about" id="about-heading">A bit about me</SectionHeading>
      <Grid>
        <Frame>
          <FrameInner>
            <img src={profile} alt="Fabio Lillman — wearing a sweater against a white background" />
          </FrameInner>
        </Frame>
        <Text $inView={inView}>
          <p>Full stack developer in Stockholm with 5+ years shipping accessible, creative web experiences. My toolkit: JavaScript, Next.js, React, and MongoDB, with an eye on accessibility, performance, and clean UI.</p>
          <p>When I'm not coding you'll find me skateboarding around town or building mods for games. Always up for new challenges and collaborations.</p>
          <ChipRow>
            <Chip>5+ YRS</Chip>
            <Chip>STOCKHOLM</Chip>
            <Chip>A11Y</Chip>
            <Chip>NEXT.JS + MONGO</Chip>
          </ChipRow>
        </Text>
      </Grid>
    </Section>
  );
};

export default About;
